import { template as template_471f1489332c4b73926b4779a4e1b599 } from "@ember/template-compiler";
import { CLIENT_TYPE_STEP_ID, isContactWizardSectionVisible } from 'client-portal/utils/contact/wizard-steps';
import { MODE_CONTACT, PRESCREENER_CATEGORIES } from 'client-portal/utils/prescreener/constants';
import { service } from '@ember/service';
import CareRecipientSelector from './care-recipient-selector';
import ClientSection from './client-section';
import Component from '@glimmer/component';
import InfoBlock from './info-block';
import LegalDisclaimer from './legal-disclaimer';
import MessageSection from './message-section';
import PartnerSection from './partner-section';
import PrescreenerRenderer from 'client-portal/components/request/prescreener/prescreener-renderer';
export default class ContactInformationFields extends Component {
    @service
    contactSteps;
    @service
    prescreener;
    get modeContact() {
        return MODE_CONTACT;
    }
    get usePrescreenerForms() {
        return this.prescreener.isPrescreenerEnabled;
    }
    get currentStepId() {
        return this.contactSteps.isEnabled ? this.contactSteps.currentStep?.id : null;
    }
    get currentCategory() {
        return this.contactSteps.currentStep?.category;
    }
    get includedCategories() {
        return this.currentCategory ? [
            this.currentCategory
        ] : [];
    }
    get excludedCategories() {
        return [
            PRESCREENER_CATEGORIES.DEMOGRAPHICS
        ];
    }
    get showClientTypeSection() {
        return (this.args.showWhoReceivingCareSection && isContactWizardSectionVisible(this.currentStepId, CLIENT_TYPE_STEP_ID));
    }
    get showDemographicsSection() {
        return isContactWizardSectionVisible(this.currentStepId, PRESCREENER_CATEGORIES.DEMOGRAPHICS);
    }
    get showAllPrescreenerCategories() {
        return this.usePrescreenerForms && !this.contactSteps.isEnabled;
    }
    get showCurrentPrescreenerCategory() {
        return (this.contactSteps.isEnabled && Boolean(this.currentCategory) && !this.showDemographicsSection);
    }
    get showLegalDisclaimer() {
        return !this.contactSteps.isEnabled;
    }
    static{
        template_471f1489332c4b73926b4779a4e1b599(`
    {{#if this.showClientTypeSection}}
      <CareRecipientSelector
        @client={{@client}}
        @clientTypes={{@clientTypes}}
        @onClientTypeChange={{@onClientTypeChange}}
      />
    {{/if}}

    {{#if this.showDemographicsSection}}
      <InfoBlock
        @client={{@client}}
        @usePrescreener={{this.usePrescreenerForms}}
        @formType={{this.modeContact}}
      />

      {{#if @showCoupleInfo}}
        <PartnerSection
          @partner={{@partner}}
          @formType={{this.modeContact}}
          @onInputChange={{@onInputChange}}
          @usePrescreener={{this.usePrescreenerForms}}
        />
      {{/if}}

      {{#if @showContactInfo}}
        <ClientSection
          @clientModel={{@clientModel}}
          @formType={{this.modeContact}}
          @onInputChange={{@onInputChange}}
          @usePrescreener={{this.usePrescreenerForms}}
        />
      {{/if}}
    {{/if}}

    {{#unless this.usePrescreenerForms}}
      <MessageSection @client={{@client}} />
    {{/unless}}

    {{#if this.showAllPrescreenerCategories}}
      <PrescreenerRenderer
        @excludeCategories={{this.excludedCategories}}
        @classes="in-contact-form in-list"
        @formType={{this.modeContact}}
        @model={{@client}}
      />
    {{/if}}

    {{#if this.showCurrentPrescreenerCategory}}
      <PrescreenerRenderer
        @includeCategories={{this.includedCategories}}
        @hideCategoryTitle={{true}}
        @classes="in-contact-form in-list"
        @formType={{this.modeContact}}
        @model={{@client}}
      />
    {{/if}}

    {{#if this.showLegalDisclaimer}}
      <LegalDisclaimer @hideDescription={{this.usePrescreenerForms}} />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
